import React, {Component} from "react";
import {Button, message, Modal} from 'antd';
import getSize from "../../utils/getSize";
import NHFetch from "../../utils/NHFetch";
import NHTable from '../common/NHTable'; 
import css from './index.css';
import {hasAuth} from "../../utils/NHCore";
import NHExcel from '../common/NHNewExcel/index'; 
const confirm = Modal.confirm;
const basicUrl = "/lqcxxxwh/";

/**
 * 录取信息管理页面
 */
class IndexComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            tempData: {}, //临时存放操作行的数据
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
                viewFlag: false,
            },
            showOperationBtn: false, //是否显示删除操作按钮
        };
    }  

    onExcelClose = () => {
        this.refs.nhTable.filterTableData();
    }
    handleImport = () => {
        this.refs.nhExcelLqxx.show();
    }

    render() {

        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '60px',
            }, {
                title: '年度',
                dataIndex: 'ND',
                width: '70px',
                searchType:"select"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType:"input"
            }, {
                title: '身份证件号',
                dataIndex: 'SFZJH',
                width: '180px',
                searchType:"input"
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '140px',
                search: 'input',
                searchType:"input"
            }, {
                title: 'EMS编码',
                dataIndex: 'KDDH',
                width: '100px',
                searchType:"input"
            } 
        ];

         
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.PKID}
                             sign={"zhxg_yxxt_lqcx_queryPage_lqxx"}
                             columns={columns} 
                             rowSelectionChange={this.rowSelectionChange}
                    >
                        {
                            hasAuth('zhxg_yxgl_jscs_lqcx:import') ?
                                <Button type="primary" onClick={this.handleImport} >导入</Button>
                                : null
                        }
                        
                    </NHTable>
                </div>  

                <NHExcel
                    ref="nhExcelLqxx"
                    title={'学生录取信息导入模板'}
                    templateName={'学生录取信息导入模板.xlsx'}
                    templateSign={'学生录取信息导入模板'}
                    exportUrl={"api/zhxg-yxxt/lqcx/importLqxx"}
                    onCancel={this.onExcelClose}
                />
            </div>
        );
    }
}

export default IndexComponent;



// WEBPACK FOOTER //
// ./components/lqcxxxwh/index.js